import { TablePagination } from "@mui/material";
import { useState } from "react";

export default function Table({ columns, rows }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  // Calculate the pagination details
  const indexOfLastRow = (page + 1) * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentItems = rows?.length > 0 && rows.slice(indexOfFirstRow, indexOfLastRow);
  const count = rows?.length;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <style>
        {`
    .overflow-y-auto::-webkit-scrollbar {
      width: 9px;
    }
    .overflow-y-auto::-webkit-scrollbar-thumb {
      background-color: rgba(155, 155, 155);
      border-radius: 10px;
    }
    .overflow-y-auto::-webkit-scrollbar-track {
      background-color: rgba(155, 155, 155, 0.1);
    }
  `}
      </style>
      <div className={`flex flex-col mr-2 shadow-md shadow-gray-200`}>
        <div className="flex flex-col  overflow-auto z-0 border h-auto border-solid  rounded-t-lg rounded-b-lg  bg-tableHeaderGray border-tableBorderGray ">
          <table className="relative w-full ">
            <thead className="w-full h-0 text-xs bg-[#EAECF0] font-medium leading-4 tracking-normal text-textGray font-inter">
              <tr className="h-0">
                {columns?.map((column, index) => (
                  <th key={index}>{column.name}</th>
                ))}
              </tr>
            </thead>
          </table>
          <div className="flex flex-col shadow-md bg-tableHeaderGray shadow-grey-200 ">
            <table className="relative w-full h-full">
              <tbody className="w-full bg-white ">
                {currentItems && currentItems?.map((row, index) => (
                  <tr key={index}>
                    {columns?.map((column, i) => (
                      <td
                        key={i}
                        className="  text-textGray py-2 border-t-[1px]"
                      >
                        {column.cell(row, index)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            <hr className="border-t-[1px] border-tableBorderGray" />
          </div>
        </div>
        <TablePagination
          component="div"
          count={count}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[7, 15, 30, 60, 100]}
        />
      </div>
    </>
  );
}